module.exports = [{"label":"Kartons","value":"karton"},{"label":"Paletten","value":"palette"}]


//////////////////
// WEBPACK FOOTER
// ./src/db/warenlieferungEinheit.json
// module id = 621
// module chunks = 0